
import React from "react";
import { Select, Spin, Avatar, Space } from "antd";
import debounce from "lodash/debounce";
import Apiauth from "../../api/Apiauth";
import { t } from "i18next";
import { FilterOutlined, SearchOutlined } from "@ant-design/icons";
import { withTranslation } from "react-i18next";

const IMG_BASE_URL = `https://assets.slipmate.ai/public/banks-logo/`;

async function fetchUserList(searchString, typeSearch) {
  if (!searchString || !typeSearch) return [];

  try {
    const res = await Apiauth.getSearchCustomer({
      typeSearch: typeSearch,
      search: searchString,
    });

    if (res.status !== 200 || !Array.isArray(res.data?.data)) return [];

    return res.data.data.map((user) => ({
      key: user.customer_uuid,
      title: `${user.name} - ${t(user?.bank_code)} - ${user.account_no}`,
      label: `${user.name} - ${user?.bank_code} - ${user.account_no}`,
      value: user.customer_uuid,
      userObject: user,
      data: {
        bankCode: user.bank_code,
        name: user.name,
      },
    }));
  } catch (error) {
    console.error("API Fetch Error:", error);
    return [];
  }
}

class DebounceSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      options: [],
      typeSearch: props?.typeSearch || "name",
      lastSearchString: "",
    };
    this.fetchRef = 0;

    // สร้าง Debounce ฟังก์ชัน
    this.debounceFetcher = debounce(
      this.loadOptions,
      props.debounceTimeout || 500,
    );
  }

  loadOptions = async (searchString) => {
    const { typeSearch } = this.state || {};
    this.setState({ lastSearchString: searchString });

    if (!searchString) {
      this.setState({ options: [], fetching: false });
      return;
    }

    this.fetchRef += 1;
    const fetchId = this.fetchRef;
    this.setState({ options: [], fetching: true });

    try {
      const newOptions = await this.props.fetchOptions(
        searchString,
        typeSearch,
      );
      if (fetchId !== this.fetchRef) return;
      this.setState({ options: newOptions, fetching: false });
    } catch (error) {
      if (fetchId === this.fetchRef) {
        this.setState({ fetching: false, options: [] });
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // หากค่าค้นหาล่าสุดมีอยู่ และประเภทการค้นหาเปลี่ยน ให้โหลดใหม่ทันที
    if (prevState.typeSearch !== this.state.typeSearch) {
      if (this.state.lastSearchString) {
        this.loadOptions(this.state.lastSearchString);
      }
    }
  }

  handleTypeSearchChange = (value) => {
    this.setState({ typeSearch: value, options: [] });
  };

  handleSelectChange = (value, option) => {
    const { setDataCustomer, onChange } = this.props;

    if (!value) {
      this.setState({ options: [], lastSearchString: "" });
      if (setDataCustomer) setDataCustomer(undefined);
      if (onChange) onChange(undefined);
    } else {
      if (setDataCustomer) setDataCustomer(option?.userObject);
      if (onChange) onChange(value);
    }
  };

  render() {
    const { fetching, options, typeSearch } = this.state;
    const { optionsType, setDataCustomer, isMobile, fetchOptions, value, ...restProps } =
      this.props || {};

    return (
      <Space.Compact style={{ width: "100%" }} direction={"vertical"}>
        <Select
          prefix={
            <>
              <FilterOutlined /> {t("filters")}:
            </>
          }
          onChange={this.handleTypeSearchChange}
          style={{ width: "100%", marginBottom: 5 }}
          value={typeSearch}
          options={optionsType}
        />
        <Select
          prefix={<SearchOutlined />}
          labelInValue
          filterOption={false}
          showSearch
          onSearch={this.debounceFetcher}
          allowClear
          notFoundContent={
            fetching ? <Spin size="small" /> : "No results found"
          }
          {...restProps}
          value={value} // รับค่าจาก Parent (Form.Item)
          options={options}
          onChange={this.handleSelectChange}
          optionRender={(option) => {
            const avatarKey = option?.data?.bankCode?.toUpperCase();
            return (
              <div style={{ textTransform: "uppercase" }}>
                {avatarKey && (
                  <Avatar
                    src={`${IMG_BASE_URL}/${avatarKey}.png`}
                    style={{ marginRight: 8 }}
                    size="small"
                  />
                )}
                {option.label}
              </div>
            );
          }}
        />
      </Space.Compact>
    );
  }
}

class SelectSearch extends React.Component {
  render() {
    // รับ value และ onChange ที่ส่งมาจาก Form.Item โดยตรง
    const { value, onChange, typeSearch, isMobile, setDataCustomer } =
      this.props;
    const optionsType = [
      { label: "UUID", value: "customer_uuid" },
      { label: t("Account No."), value: "account_no" },
      { label: t("Name"), value: "name" },
      { label: t("telephoneNumber"), value: "telephoneNumber" },
    ];
    return (
      <DebounceSelect
        value={value}
        onChange={onChange}
        placeholder={t("Search...")}
        fetchOptions={fetchUserList}
        setDataCustomer={setDataCustomer}
        typeSearch={typeSearch}
        optionsType={optionsType}
        isMobile={isMobile}
        style={{ width: "100%" }}
      />
    );
  }
}

export default withTranslation()(SelectSearch);
